import React, { ReactElement } from 'react';

import { Button } from '@accesa/react-core/build/form/button';
import { Modal } from '@accesa/react-core/build/layout/modal';

import { CancelModalProps } from './props';
import useConstLang from './lang';


const CancelModal: React.FC<CancelModalProps> = ({
  isModalOpen,
  goBackHandler,
  triggerModal,
  text
}: CancelModalProps): ReactElement => {
  const T = useConstLang();
  return (
    <Modal
      isOpen={isModalOpen}
      handleClickOutside={() => triggerModal(false)}
      hasHeaderButton={false}
      title={T.title}
      style={{ minWidth: '328px', maxWidth: '330px' }}
      actions={[
        <Button
          appearance="secondary"
          isDismiss={true}
          text={T.cancelEditingButton}
          onClick={() => goBackHandler()}
        />,
        <Button
          appearance="primary"
          text={T.closeButton}
          onClick={() => triggerModal(false)}
        />
      ]}
    >
      <div style={{ whiteSpace: 'pre-line' }}>
        {text}
      </div>
    </Modal>
  );
};

export default CancelModal;